import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import styles from './InputLabel.module.scss';
const InputLabel = ({ children, className, color = 1 }) => (_jsx(Paragraph, { color: 'grey', size: 1, title: children, className: cn(styles.element, className) }));
export default InputLabel;
